import * as React from 'react'
import { Form } from 'react-bootstrap'
import moment from 'moment';
import * as _ from "lodash";
import { useSelector } from 'react-redux'

import { JobMode } from '../../../Job'
import {  AxiosInstance } from '../../../../../../utils/RequestMethods'
import config from '../../../../../../constants/config'
import { copyObject } from '../../../../../../utils';
import { CompanyT } from '../../../../../../types/Company';
import { getVariableValue, VariableDocumentT, setValueVariables } from '../../DocumentVariables';

import ListAgreements from '../../ListAgreements';
import { AgreementT, JobT } from '../../../../../../types/Job';
import { ConsumerAdvisementObj } from '../../../InitObjectJob';
import { IAppState } from '../../../../../../redux/reducers';
import toast, { Toaster } from 'react-hot-toast';
import { defaultOptionsToast, ToastMessage } from '../../../../../../constants/defaultOptionsToast';

interface ConsumerAdvisementProps {
  company: CompanyT
  job: JobT
  jobOrigin: JobT
  jobMode: JobMode
  nextDocument(): void
  refreshJob(newJob: JobT): void
  saveJob(): Promise<JobT>
  updateJob(key: string, value: any): void
}



const ConsumerAdvisement: React.FunctionComponent<ConsumerAdvisementProps> = ({ company, job, jobOrigin, jobMode, nextDocument, refreshJob, saveJob, updateJob }): JSX.Element => {
  const [checked, setChecked] = React.useState(false);
  const [currentVariables, setCurrentVariables] = React.useState(null)
  const [isReady, setIsReady] = React.useState(false)
  let auth = useSelector((state: IAppState) => state.auth)

  const userRole = auth.userData && auth.userData.roles ? auth.userData.roles[0] : []
  const refBtnSave = React.useRef(null)

  React.useEffect(() => {
    if (!isReady) {
      let variables = job.documents.consumerAdvisement && job.documents.consumerAdvisement.variables
      // console.log('currentVariables', currentVariables)
      // console.log('currentVariables->variables', job.documents.consumerAdvisement)
      let cloneVariables = copyObject(currentVariables)
      if (variables && !_.isEqual(variables, currentVariables)) {
        cloneVariables = copyObject(ConsumerAdvisementObj.variables)
      } else {
        // update parent job
        updateDocumentVariables(copyObject(cloneVariables))
      }
      // console.log('currentVariables->cloneVariables', cloneVariables)
      setCurrentVariables(copyObject(cloneVariables))
    }

    setIsReady(true)
  }, [job.documents.estimate]);


  //  saveAcknowledge
  const clickSaveAcknowledge = async (): Promise<void> => {
    // disabled Acknowledge
    setChecked(true)
    try {
      let res = await saveAcknowledge();
      //console.log("saveAcknowledge", res)
      setChecked(false)
      if (res && res.data) {
        let data: JobT = res.data
        refreshJob(data)
        nextDocument()
      }

    } catch (error) {
      setChecked(false)
      const msgError = _.has(error, "message") ? `${error.message}` : `${error}`
      toast.error((t) => (
        <ToastMessage message={msgError} t={t} />
      ), defaultOptionsToast);

    }
  }



  let getAgreements = (job: JobT): Array<AgreementT> => {
    if (!job.documents.consumerAdvisement || !job.documents.consumerAdvisement.agreement) {
      return [];
    }
    const agreements = _.isArray(job.documents.consumerAdvisement.agreement) ? job.documents.consumerAdvisement.agreement : []
    return agreements
  }


  //  isAckCA
  const isAckCA = (job: JobT): boolean => {
    if (!job.documents.consumerAdvisement || !job.documents.consumerAdvisement.agreement) {
      return false;
    }

    const agreements = getAgreements(job);
    if (_.isArray(agreements) && agreements.length > 0) {
      const findItem = agreements.find((x) => _.isEqual(x.content, job.documents.consumerAdvisement.variables))
      if (findItem) {
        return true;
      }
    }
    return false;
  }


  // updateDocumentVariables
  const updateDocumentVariables = (variables: Array<VariableDocumentT>): void => {
    let documentsClone = copyObject(job.documents)
    if (!documentsClone.consumerAdvisement) {
      documentsClone = { ...documentsClone, ...{ consumerAdvisement: copyObject(ConsumerAdvisementObj) } }
    } else {
      documentsClone.consumerAdvisement.variables = variables;
    }

    updateJob('documents', documentsClone)
  }

  /**
  *
  */
  const saveAcknowledge = async (): Promise<any> => {
    let url = `${config.url.wpJson}/wp/v2/jobs/${job.id}/agreements`
    //console.log('currentVariables->currentVariables', currentVariables)
    let params = {
      name: 'consumerAdvisement',
      type: 'acknowledgement',
      clause: 'I acknowledge that I have been given a copy of this consumer advisement to keep for my records.',
      content: currentVariables,
    }
    return await AxiosInstance.post(url, params)
  }

  const sortAgreementsByTimesTamp = (agreements) => {
    return agreements.sort((a, b) => b.timestamp - a.timestamp)
  }



  const getVariablesCA = (newJob: JobT, useDefault: boolean = true): Array<VariableDocumentT> => {
    return newJob.documents.consumerAdvisement && newJob.documents.consumerAdvisement.variables ? newJob.documents.consumerAdvisement.variables : useDefault ? copyObject(ConsumerAdvisementObj.variables) : []
  }

  const renderAgreePortion = (): JSX.Element => {
    if (jobMode != JobMode.Edit) {
      return null;
    }

    if ((userRole.includes('administrator') || userRole.includes('manager')) && !isAckCA(job)) {
      return (
        <div>
          <span className="text-danger">Client has not yet agreed to Consumer Advisement.</span>
        </div>
      )

    } else if (userRole.includes('client')) {
      return (
        <div>
          {(checked || isAckCA(job)) == false && <div><span className="text-danger">You must agree to these terms.</span></div>}
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Form.Check
              inline
              // custom
              id={`${"custom-inline-ConsumerAdvisement"}`}
              disabled={!checked && !isAckCA(job) ? false : true}
              onChange={(e) => { clickSaveAcknowledge() }}
              checked={checked || isAckCA(job)}
              type='checkbox' />
            <a id="anchor-agreement-consumerAdvisement" ></a>
            <div>
              <p>I acknowledge that I have been given a copy of this consumer advisement to keep for my records</p>

            </div>
          </div>
        </div>
      )
    }
    return null;
  }

  return (
    <div>
      <h1>Consumer Advisement</h1>
      <p>Intrastate movers in Colorado are regulated by the Colorado Public Utilities Commission (PUC).  Each mover should have a PUC permit number.  You are encouraged to contact the PUC to confirm that the mover you are using is indeed permitted in Colorado.</p>
      <p>A mover that is not permitted may not withhold any of your property to enforce payment of money due under the contract ('carrier's lien').</p>
      <p>A mover must include its PUC permit number, true name, and physical (street) address in all advertisements.</p>
      <p>You should be aware that the total price of any household move can change, based on a number of factors that may include at least the following:</p>
      <ul>
        <li key={0}>Additional services you request at the time of the move;</li>
        <li key={1}>Additional items to be moved that were not included in the mover's original estimate;</li>
        <li key={2}>Changes to the location or accessibility of building entrances, at either end of the move, that were not included in the mover's original estimate; and</li>
        <li key={3}>Changes to the previously agreed date of pickup or delivery.</li>
      </ul>
      <p>You should also be aware that, in case of a dispute between you and the mover, Colorado has an arbitration process available to resolve the dispute without going to court.</p>
      <p>If you have any questions, you are encouraged to call the PUC at (303) 894-2070 for guidance on your rights and obligations.</p>
      <h3>Signature</h3>
      {renderAgreePortion()}
      <ListAgreements
        agreements={getAgreements(job)}
        currantContent={getVariablesCA(job)}
      />

    </div>
  )
}

export default ConsumerAdvisement
